<template>
  <ReviewStep>
    <ReviewSection v-if="is3rdParty"
      title="On Behalf Of Information"
      @edit="goToStep('Contact Info')"
    >
      <div>
        <div>{{ onBehalfOfFirstName }} {{ onBehalfOfLastName }}</div>
        <div>{{ onBehalfOfAddressLine1 }}</div>
        <div v-if="onBehalfOfAddressLine2">{{ onBehalfOfAddressLine2 }}</div>
        <div>{{ onBehalfOfCity }}, {{ onBehalfOfState }} {{ onBehalfOfZip }}</div>
      </div>
    </ReviewSection>

    <ReviewSection title="Requestor Information"
      @edit="goToStep('Contact Info')"
    >
      <div>
        <div>{{ fromFirstName }} {{ fromLastName }}</div>
        <div v-if="fromOrganization">{{ fromOrganization }}</div>
        <div>{{ fromAddressLine1 }}</div>
        <div v-if="fromAddressLine2">{{ fromAddressLine2 }}</div>
        <div>{{ fromCity }}, {{ fromState }} {{ fromZip }}</div>
      </div>
      <div v-if="fromEmail">
        <label class="form-label">Email</label>
        <div>{{ fromEmail }}</div>
      </div>
      <div v-if="fromPhone">
        <label class="form-label">Phone</label>
        <div>{{ fromPhone }}</div>
      </div>
      <div v-if="fromFax">
        <label class="form-label">Fax</label>
        <div>{{ fromFax }}</div>
      </div>
    </ReviewSection>

    <ReviewSection title="Request Details"
      @edit="goToStep('Request Details')
    ">
      <div v-if="comments">
        <label class="form-label">Request Description</label>
        <div>{{ comments }}</div>
      </div>
      <div v-if="attachments.length">
        <div><label class="form-label">Documentation</label></div>
        <ul>
          <li v-for="{ name } in attachments
              .sort((a, b) => a.name.localeCompare(b.name))
            "
            :key="name"
            class="file-name"
          >{{ name }}</li>
        </ul>
      </div>
    </ReviewSection>

    <ReviewSection title="Other Details"
      @edit="goToStep('Other Details')
    ">
      <div>
        <label class="form-label">Fee Waiver Requested</label>
        <div>{{ feeWaiverRequested ? 'Yes' : 'No' }}</div>
      </div>
      <div v-if="feeWaiverRequested">
        <label class="form-label">Waiver Justification</label>
        <div>{{ feeWaiverJustification }}</div>
      </div>
      <div v-else>
        <label class="form-label">Max Fee Amount</label>
        <div>{{ maxFeeAmount | formatCurrency }}</div>
      </div>

      <div>
        <label class="form-label">Expedited Processing Requested</label>
        <div>{{ expeditedProcessingRequested ? 'Yes' : 'No' }}</div>
      </div>
      <div v-if="expeditedProcessingRequested">
        <label class="form-label">Expedition Justification</label>
        <div>{{ expeditionJustification }}</div>
      </div>
    </ReviewSection>
  </ReviewStep>
</template>

<script>
import subComponent from '@ssi/vue-common/src/mixins/subComponent';
import ReviewStep from '@/components/requestWizard/ReviewStep';
import ReviewSection from '@/components/requestWizard/ReviewSection';

export default {
  mixins: [subComponent],

  components: { ReviewSection, ReviewStep },

  props: {
    is3rdParty: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    goToStep(name) {
      this.$emit('go-to-step', name);
    }
  }
};
</script>
